import React from 'react';

import { ModuleDispatcher } from '$partials/modules/index.js';
import { PageShell } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').GenericDetailPage}
 */
const GenericDetailPage = (props) => {
    const page = props.data?.page;

    const content = page?.content || [];

    return (
        <PageShell
            banner
            footer={props.data?.footer}
            header={props.data?.header}>
            {/* Page header */}
            <div className='layout-container bg-neutral-00'>
                {/* The negative margin removes some of the top padding of the
                    first module below, as per the design. */}
                <div className='py-16 sm:py-40 -mb-25'>
                    <div className='layout-grid flex-col sm:flex-row gap-y-16 sm:gap-y-0'>
                        <div className='w-full sm:w-4/12 lg:w-3/12 layout-grid-col'>
                            <div className='sm:sticky sm:top-110'>
                                <h1 className='type-style-heading'>
                                    {page?.title}
                                </h1>

                                {page?.introduction && (
                                    <div
                                        className='rich-text type-style-heading'
                                        dangerouslySetInnerHTML={{ __html: page.introduction }} />
                                )}
                            </div>
                        </div>

                        <div className='w-full sm:w-8/12 layout-grid-col'>
                            {/* Push heading down */}
                            <div
                                aria-hidden={true}
                                className='hidden sm:block sm:w-4/8 lg:w-3/8 text-transparent type-style-heading select-none pointer-events-none'>
                                {page?.title}
                            </div>

                            {page?.heading && (
                                <p className='type-style-heading sm:w-5/8'>{page.heading}</p>
                            )}

                            {page?.text && (
                                <div
                                    className='rich-text type-style-body mt-8 sm:mt-10 sm:w-4/8'
                                    dangerouslySetInnerHTML={{ __html: page.text }} />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Streamfield modules */}
            {content.length > 0 && (
                <div>
                    {content.map((module) => (
                        <ModuleDispatcher
                            key={module.id}
                            modulePaddingClasses='py-24 sm:py-32'
                            parent={page.__typename}
                            { ...module } />
                    ))}
                </div>
            )}
        </PageShell>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default GenericDetailPage;
